import createDebugger from 'debug';
import Raven from 'raven-js';
import { stringify } from 'flatted';
import shouldLogError from 'common/util/shouldLogError';
import objectDiff from 'common/util/objectDiff';
import checkLocalStorage from 'common/util/checkLocalStorage';

const { NODE_ENV } = process.env;

const hasLocalStorage = checkLocalStorage();

const stringifyArgs = (args) =>
  args.map((arg) => {
    if (typeof arg === 'object' && arg) {
      return stringify(arg, null, 2);
    }
    return arg;
  });

const log =
  NODE_ENV === 'production'
    ? {
        _debuggers: {},
        info: (args) => {
          if (process.browser) {
            console.log(args); // eslint-disable-line no-console
          }
        },
        warn: (args) => {
          if (process.browser) {
            console.warn(args); // eslint-disable-line no-console
          }
        },
        error: (error) => {
          if (shouldLogError(error)) {
            if (global.__log) {
              global.__log.error(error);
            }
            if (process.browser) {
              Raven.captureException(error);
            }
          }
        },
        diff() {
          return {};
        },
        debug(key) {
          let debug = this._debuggers[key];
          if (!debug) {
            debug = (...args) => {
              if (hasLocalStorage) {
                try {
                  const enableDebug = global.localStorage.getItem('sunroom:enableDebug');
                  if (enableDebug === 'true') {
                    console.log(...stringifyArgs(args)); // eslint-disable-line no-console
                  }
                } catch (error) {
                  log.error(error);
                }
              }
            };
            this._debuggers[key] = debug;
          }
          return debug;
        },
      }
    : {
        _debuggers: {},
        info: (...args) => {
          if (global.__log) {
            global.__log.info(...args);
          } else {
            console.log(...args); // eslint-disable-line no-console
          }
        },
        warn: (...args) => {
          if (global.__log) {
            global.__log.warn(...args);
          } else {
            console.warn(...args); // eslint-disable-line no-console
          }
        },
        error: (error) => {
          if (shouldLogError(error)) {
            if (global.__log) {
              global.__log.error(error);
            } else {
              console.error(error); // eslint-disable-line no-console
              if (process.browser) {
                Raven.captureException(error);
              }
            }
          }
        },
        diff: (obj1, obj2) => objectDiff(obj1, obj2),
        debug(key) {
          let debug = this._debuggers[key];
          if (!debug) {
            debug = createDebugger(key);
            this._debuggers[key] = debug;
          }
          return (...args) => {
            if (hasLocalStorage && global.localStorage.getItem('sunroom:enableDebug') === 'true') {
              log.info(...args);
            }
            debug(...args);
          };
        },
      };

export default log;
